import styled from "@emotion/styled";

export const NotificationsWrapper = styled.div`
  margin-block-end: 25px;
`;
